module.exports = __webpack_public_path__ + "img/loisir4.40118d52.jpg";